export default __webpack_public_path__ + "static/media/logo.710405e3.png";